var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"white--text",attrs:{"block":"","color":_vm.buttonColor},on:{"click":_vm.onAbsentClicked}},[(_vm.buttonState)?_vm._t("confirmText",[_vm._v("\n    Confirmar\n  ")]):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }